<template>
    <div class="ui-content dashboard leader-sub">
        <!-- <div class="prev-test-date">
            All Premium Papers live till upcoming
            <span>
                May 31<sup>st</sup>
            </span>
        </div> -->
        <div class="readymadetest-name-search">
            <div class="search-test-name">
                <v-text-field
                  v-model="testName"
                  @keydown="onSearchTest()"
                  label="Test Name"
                  dense
                  outlined
                  hide-details
                  append-icon="search"
                  autocomplete="off"
                ></v-text-field>
            </div>
        </div>
        <div class="user leaderboard-tab">
            <v-tabs
                v-model="tab"
                background-color
                class="elevation-2 cust-tab"
                :centered="centered"
                :grow="grow"
                :vertical="vertical"
                :right="right"
                :prev-icon="prevIcon ? 'mdi-arrow-left-bold-box-outline' : undefined"
                :next-icon="nextIcon ? 'mdi-arrow-right-bold-box-outline' : undefined"
                :icons-and-text="icons"
            >
                <v-tabs-slider></v-tabs-slider>
                <v-tab
                    v-for="(tType) in tTypes"
                    :key="tType.value"
                    :href="'#' + tType.value"
                >{{ tType.text }}
                </v-tab>
            </v-tabs>
        </div>
        <v-card class="mx-auto normal-card">
            <div class="data-table-section prev-test-tb">
                <v-data-table
                    :headers="headers"
                    fixed-header
                    :items="items"
                    hide-default-header
                    hide-default-footer
                    class="elevation-2 cust-table"
                >
                    <template v-slot:header="{ props: { headers } }">
                        <TableHeader
                            :headers="headers"
                            :onSortChange="onSortChange"
                            :orderBy="orderBy"
                            :onHeaderAction="onHeaderAction"
                        />
                    </template>
                    <template v-slot:body="{ items }">
                        <tbody>
                            <tr v-for="item in items" :key="item.name">
                                <td class="text-center" @click="gotoTest(item)">{{item.test_name}}</td>
                                <td class="text-center">{{item.duration}}</td>
                                <td class="text-center">{{item.test_sub_type_name}}</td>
                                <td class="text-center">{{item.target_name}}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-data-table>
                <div class="btm-test-prev-test">Click on a test name to start answering that test</div>
            </div>
        </v-card>
        <div class="footer-btn">
            <div class="pull-left"></div>
            <div class="pull-right">
                <Pagination
                    :currentPage="currentPage"
                    :totalPage="totalPages"
                    :onPageChange="onPageChange"
                />
            </div>
        </div>
        <AlertBox
            :width="modalwidth"
            :onClose="onClose"
            :component="cComponent"
            :status="status"
            :data="alertBoxData"
        />
    </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
import { detect } from "detect-browser";

export default {
    name: "Ready-made-tests",
    mounted() {
        this.defaultData();
        this.checkSessionData();
        this.browserInfo = detect();
        this.sendToUpgradeScreen = this.checkIsDefaultInstitute();
		this.modules=JSON.parse(localStorage.getItem('modules'));
    },
    data() {
        return {
            icons: false,
            centered: false,
            grow: false,
            vertical: false,
            prevIcon: false,
            nextIcon: false,
            right: false,
            tab: 1,
            headers: [
                {
                    text: "Test Name",
                    value: "test_name",
                    class: "text-center"
                },
                {
                    text: "Duration(Min)",
                    value: "duration",
                    class: "text-center",
                    hideSort: true
                },
                {
                    text: "Test Sub Type",
                    value: "selectedSubTestTypes",
                    class: "text-center",
                    type: "multidropdown",
                    options: [],
                    allText: "All Test Subtypes"
                },
                {
                    text: "Target Exam",
                    value: "target_exam",
                    class: "text-center",
                    hideSort: true
                }
            ],
            items: [],
            examTypes: [],
            orderBy: {
                field: "test_name",
                order: "ASC"
            },
            currentPage: 1,
            pageSize: 10,
            totalPages: 1,
            selectedExamTypes: [],
            alertBoxData: null,
            status: false,
            cComponent: "",
            modalwidth: null,
            browserInfo: null,
            sendToUpgradeScreen: true,
            testName: null,
            selectedTestTypes:[],
            selectedSubTestTypes:[],
            subTestTypes:[],
            modules:[],
            typetimeout:null,
            tTypes:null,
            isApiCall: true
        };
    },
    computed: {
        ...mapState("userStore", ["user"])
    },
    methods: {
        ...mapMutations("app", ["addBreadCrumbChilde"]),
        ...mapActions({
            getTestList: "testStore/getTestList",
            getPackages: "userStore/getPackages",
            getTestTypes: "utilStore/getTestTypes",
      		getTestSubTypes: "utilStore/getTestSubTypes",
            testAttempted: "testStore/testAttempted",
        }),
        setTabKey(tabName) {
            return tabName.split(" ").join("");
        },
        defaultData() {
            let routeName = this.$route.name;
            let crd = this.getCurrentRouteDetails(routeName);
            if(crd && crd.selectedTab) {
                this.currentPage = crd.tabDetails[crd.selectedTab].currentPage;
                this.selectedSubTestTypes = crd.tabDetails[crd.selectedTab].selectedSubTestTypes;
                this.tab = crd.selectedTab ? crd.selectedTab : 1;
                // this.tabValue = crd.tabDetails[crd.selectedTab].tabValue;
            }
		    this.requestGetTestTypes();
        },
        updateCurrentRouteDetails(fieldName, fieldValue) {
          let routeName = this.$route.name;
                let crd = this.getCurrentRouteDetails(routeName);
                crd.tabDetails[crd.selectedTab][fieldName] = fieldValue;
                this.setRouteDetails(crd);
        },
        checkSessionData() {
            let rp = this.$route; // route params
            let crd = this.getCurrentRouteDetails(rp.name);
            
            if(rp.params.resetPage || !crd.routeName) {
                let orderField = 'test_name';
                let tabDetail = {
                    1: {
                        page: 1,
                        orderBy: {
                            field: orderField,
                            order: "ASC"
                        }
                    },
                    2: {
                        page: 1,
                        orderBy: {
                            field: orderField,
                            order: "ASC"
                        }
                    },
                    3: {
                        page: 1,
                        orderBy: {
                            field: orderField,
                            order: "ASC"
                        }
                    }
                };
                let routeDetails = {
                    routeName: rp.name,
                    selectedTab: this.tab,
                    tabDetails: tabDetail
                }
                this.setRouteDetails(routeDetails);
            }
        },
        checkBrowserSupport() {

            if (!this.browserInfo || !this.browserInfo.name) return false;
            let browserName = this.browserInfo.name;
            let nAgent = navigator.userAgent.toLowerCase();
            let isSupported = true;
            this.UNSUPPROTED_BROWSERS.forEach((browser) => {
                if (nAgent.includes(browser)) {
                    isSupported = false;
                }
            });

            if (
                isSupported &&
                (browserName == "firefox" ||
                    browserName == "chrome" ||
                    browserName == "safari" ||
                    browserName == "crios" ||
                    browserName == "fxios" ||
                    browserName == "ios")
            ) {
                return true;
            }
            return false;
        },
        onClose(data) {
            this.status = data.status;
        },
        showBrowserMessage() {
            this.cComponent = "components/common/BrowserSupport";
            this.modalwidth = "700px";
            this.status = true;
            this.alertBoxData = { persistent: false };
        },
        gotoTest(test) {
            if (this.checkBrowserSupport()) {
                let routeName = this.$route.name;
                localStorage.setItem("previousRoute", routeName);
                let reqData = {
                    test_institute_id: test.test_institute_id,
                    student_id: this.user.id,
                }
                this.testAttempted(reqData)
                .then((response) =>{
                    if(response){
                        localStorage.setItem("previousPath", this.$route.path);
                        this.$router.push({
                            name: "instructions-about-test",
                            params: {
                                test_id: test.id,
                                test_institute_id: test.test_institute_id,
                            },
                        })
                    }
                })
                .catch((err) => {
                this.loading = false;
                }); 
            } else {
                this.showBrowserMessage();
            }
        },
        onPageChange(e) {
            this.currentPage = e;
            
            if (!this.isApiCall) {

                this.requestGetTestsList(this.tab);
            }
            this.updateCurrentRouteDetails();
        },
        onSortChange() {
            this.currentPage = e;
            if (!this.isApiCall) {

                this.requestGetTestsList(this.tab);
            }
        },
        onHeaderAction(e) {
            if (e.data && e.data.selectedItems) {
                this[e.header.value] = e.data.selectedItems;
                let routeName = this.$route.name;
                let crd = this.getCurrentRouteDetails(routeName);
                if(crd && crd.selectedTab) {
                crd.tabDetails[crd.selectedTab].selectedSubTestTypes = e.data.selectedItems;
                }
                this.setRouteDetails(crd);
            }
        },
        requestGetTestsList(tType) {
            this.getSubTypes();
            let reqData = {
                isReadyMadeTest: true,
                orderBy: this.orderBy,
                pagination: { page: this.currentPage, pageSize: this.pageSize },
                test_types: [this.tab]
            };
            if (this.selectedSubTestTypes && this.selectedSubTestTypes.length) {
                reqData.test_sub_types = this.selectedSubTestTypes;
            }
            if (this.testName) {
                reqData.test_name = this.testName
            }
            this.$root.showLoader = true;
            this.getTestList(reqData)
                .then(response => {
                    if (response.list.length == 0 && this.currentPage != 1 && !this.$route.query.resetPage) {
                        this.onPageChange(1);
                        return;
                    }
                    this.$root.showLoader = false;
                    this.items = response.list;
                    this.isApiCall = false;
                    this.totalPages = response.pagination.pageCount;
                })
                .catch(err => {
                    this.$root.showLoader = false;
                });
        },
        requestGetTestTypes() {
            this.getTestTypes()
            .then(response => {
                this.tTypes = response.data.filter(xx => xx.id !== this.TEST_TYPE.CUSTOM && xx.id !== this.TEST_TYPE.MYT && xx.id !== this.TEST_TYPE.PRACTICE_SESSION && xx.id !== this.TEST_TYPE.IMPROVEMEN_ASSIGNMENT).map(x => {
                    return {
                        text: x.name,
                        value: x.id,
                    }
                });
                // this.tab = this.tTypes[0].value
                this.requestGetTestsList(this.tab);
            })
            .catch(err => {
                this.$root.showLoader = false;
            });
        },
        getSubTypes() {
            let postData = {
            };
            postData.main_types = [this.tab];
            this.getTestSubTypes(postData)
                .then((response) => {
                    this.subTestTypes = response.map(x => {
                        return {
                            text: x.name,
                            value: x.id,
                            checked: this.selectedSubTestTypes && this.selectedSubTestTypes.includes(x.id) ? true : false

                        }
                    });
                    this.headers[2].options = this.subTestTypes;
                })
                .catch((err) => {
                    this.$root.showLoader = false;
                });
        },
        onSearchTest() {
            this.resetFields();
            if (this.typetimeout) {
                clearTimeout(this.typetimeout);
            }
            this.typetimeout = setTimeout(() => {
                if (!this.isApiCall) {

                    this.requestGetTestsList(this.tab);
                }
            }, 1500);
        },
        resetFields() {
            this.currentPage = 1;
            this.pageSize = 10;
            this.totalPages = 1;
        },
    },
    watch: {
        selectedSubTestTypes(val) {
            if (val) {
                this.resetFields();
                if (!this.isApiCall) {

                    this.requestGetTestsList(this.tab);
                }
            }
        },
        currentPage(val) {
            let routeName = this.$route.name;
            let crd = this.getCurrentRouteDetails(routeName);
            if(crd && crd.selectedTab){
                crd.tabDetails[crd.selectedTab].currentPage = val;
                this.setRouteDetails(crd);
            }
        },
        tab(val, oldVal) {
            if(oldVal) { // only when tab is changed and not on page load
                this.selectedSubTestTypes = null;
                let routeName = this.$route.name;
                this.setRouteDetails({ routeName, selectedTab: val });
                let crd = this.getCurrentRouteDetails(routeName);
                this.resetFields();
                this.testName = null;
                this.getSubTypes();
                this.requestGetTestsList(this.tab);
            }
            let routeName = this.$route.name;
            let crd = this.getCurrentRouteDetails(routeName);
            let test = this.tTypes && this.tTypes.length ? this.tTypes.find(t => t.value == val) : { text: "Proficiency" }
            this.addBreadCrumbChilde([
                {
                    text: test.text,
                    disabled: false
                }
            ]);
            
        }
    }
};
</script>